export class CasoMailbox {

  public PersonaId: number;
  public AlertaId: number;

  constructor() {
    this.PersonaId = -1;
    this.AlertaId = 1;
  }

}
